export { Manifesto } from './view/Manifesto'
export type { ManifestoProps } from './view/Manifesto'

export { Why as ManifestoWhy } from './components/Why'
export { Who as ManifestoWho } from './components/Who'
export { How as ManifestoHow } from './components/How'
export { OurCriteria as ManifestoOurCriteria } from './components/OurCriteria'
